import React, { useState } from 'react';
import { RootState } from 'typesafe-actions';
import { connect } from 'react-redux';
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  List as MuiList,
  ListItem as MuiListItem,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import './Selector.css';
import {
  closeDisplays
} from '../state/uiControl/uiControl.actions';

type ItemType = { id: string; name: string };

type OwnSelectorProps = {
  expanded: boolean;
  toggleExpand: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
  items: ItemType[];
  isVoyageSelector?: boolean;
  selectItemAction: (payload: string) => void;
  selectedIndex: number;
  setIndex?: (index: number) => void;
  dontListFirstItem?: boolean;
}

const Accordion = withStyles({
  root: {
    color: '#304153',
    backgroundColor: 'transparent',
    fontFamily: 'OpenSans',
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {}
})(MuiAccordion);

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(0, 2),
  },
}))(MuiAccordionDetails);

const AccordionSummary = withStyles(theme => ({
  root: {
    borderRadius: '25px',
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
    },
    '&$expanded': {
      minHeight: '48px',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const List = withStyles(theme => ({
  root: {
    padding: theme.spacing(0),
  },
}))(MuiList);

const ListItem = withStyles(theme => ({
  root: {
    fontSize: '10px',
    opacity: 1,
  },
}))(MuiListItem);

const selectedColor = '#993A59';
const unselectedColor = 'rgba(96, 96, 96, 1.0)';

const Selector: React.FC<SelectorProps> = (props) => {
  const {
    expanded,
    toggleExpand,
    items,
    // isVoyageSelector,
    selectItemAction,
    selectedIndex,
    setIndex,
    // closeDisplays,
    dontListFirstItem
  } = props;

  const [open, setOpen] = useState(false);
  const selectedItem = items[selectedIndex] ? items[selectedIndex] : items[0];

  return (
    <Accordion elevation={0} expanded={expanded} onChange={toggleExpand}>
      <AccordionSummary expandIcon={<ExpandMore />} >
        <Typography variant="body1">{selectedItem.name}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List>
          {items
            .map((item: any, index: number) => {
              if (dontListFirstItem && index === 0) {
                return null;
              }
              const color = {
                color: item === selectedItem
                  ? selectedColor
                  : unselectedColor,
                opacity: 1,
              };
              return (
                <ListItem
                  button
                  key={item.id}
                  // disabled={item === selectedItem}
                  onClick={() => {
                    selectItemAction(item.id);
                    setIndex?.(index);
                    setOpen(!open);
                  }}
                  style={color}
                >
                  <Typography variant="body2">
                    {item.name}
                  </Typography>
                </ListItem>);
            })}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = (state: RootState, ownProps: OwnSelectorProps) => (ownProps);

const dispatchProps = {
  closeDisplays
};

type SelectorProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(Selector);